import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Share2, Camera, UserPlus, Clock, ShieldCheck, Megaphone, Flag, MessageCircle, Users, Star, Eye, CalendarDays, Heart, Gift, Crown, Store, Coins } from "lucide-react";

export const VipBadge = () => null;

export const fmtK = (v) => String(Math.round((Number(v) || 0) * 100) / 100);

let ratePromise = null;
export function useEurRate() {
  const [r, setR] = useState(null);
  useEffect(() => {
    if (!ratePromise) ratePromise = api.get("/credits/rate").then((x) => x.data.eur || 0).catch(() => { ratePromise = null; return 0; });
    ratePromise.then(setR);
  }, []);
  return r;
}

export const fmtEur = (v) => { const n = Math.abs(v); return `${n > 0 && n < 0.01 ? n.toFixed(4) : n.toFixed(2)} €`; };

// Shows the euro value of a credit amount in small text
export function Eur({ v, className = "", sign = false }) {
  const r = useEurRate();
  if (!r) return null;
  const e = (Number(v) || 0) * r;
  return <span data-testid="eur-value" className={`block text-[11px] font-semibold text-slate-500 ${className}`}>{sign && e > 0 ? "+" : sign && e < 0 ? "−" : "≈ "}{fmtEur(e)}</span>;
}

export const POINT_ICONS = { share: Share2, camera: Camera, "user-plus": UserPlus, clock: Clock, shield: ShieldCheck, megaphone: Megaphone, flag: Flag,
  message: MessageCircle, users: Users, star: Star, eye: Eye, calendar: CalendarDays, heart: Heart, gift: Gift, crown: Crown, store: Store, coins: Coins };

export const PointIcon = ({ name, className }) => {
  const I = POINT_ICONS[name] || Star;
  return <I className={className} />;
};

export const Coin = ({ size = 40 }) => (
  <img src="/gjejkredit.png" alt="GjejKredit" className="shrink-0 rounded-full object-contain" style={{ width: size, height: size }} />
);

const MONTHS = ["Jan", "Shk", "Mar", "Pri", "Maj", "Qer", "Korr", "Gush", "Sht", "Tet", "Nën", "Dhj"];
export const fmtDate = (iso) => { const d = new Date(iso); return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`; };
